import {
  UserOutlined,
  BellOutlined,
  ShopOutlined,
  RobotOutlined,
  SafetyOutlined,
  ProfileOutlined,
  ProjectOutlined,
  OneToOneOutlined,
  CalendarOutlined,
  CreditCardOutlined,
  ThunderboltOutlined,
  AccountBookOutlined,
  DatabaseOutlined,
  StarOutlined,
  LineChartOutlined,
} from '@ant-design/icons'
import { lazy } from 'react'
import { userTypeMap, ResourceMap } from '../utils/consts'

export const getManageCenterRoutes = (
  manageCenterResource: ResourceMap['manageCenter'],
  user: User,
  region: Region
) => {
  const manageCenterRoutes = [
    {
      path: '/manageCenter',
      resource: manageCenterResource.index,
      component: require('../app/ManageLayout').default,
      routes: [
        {
          path: '/manageCenter/illegalAdIdentification',
          name: '违法小广告识别',
          icon: LineChartOutlined,
          resource: manageCenterResource.illegalAdIdentification && !!region?.entityCode,
          component: lazy(() => import('../pages/manageCenter/illegalAdIdentification')),
        },
        {
          path: '/manageCenter/licenseVerifyTool',
          name: '牌照/扫码核验工具',
          icon: DatabaseOutlined,
          resource: manageCenterResource.licenseVerifyTool,
          routes: [
            {
              path: '/manageCenter/licenseVerifyTool/register',
              name: '牌照/扫码记录',
              resource: manageCenterResource.registerScanDetail,
              component: lazy(() => import('../pages/manageCenter/licenseVerifyTool/register')),
            },
            {
              path: '/manageCenter/licenseVerifyTool/blockingWords',
              name: '牌照识别规则配置',
              resource: manageCenterResource.shieldWordsConfig,
              component: lazy(
                () => import('../pages/manageCenter/licenseVerifyTool/blockingWords')
              ),
            },
            {
              path: '/manageCenter/licenseVerifyTool/duplicateCode',
              name: '重码/牌提醒配置',
              resource: manageCenterResource.duplicateCodeConfig,
              component: lazy(
                () => import('../pages/manageCenter/licenseVerifyTool/duplicateCode')
              ),
            },
          ],
        },
        {
          path: '/manageCenter/complaintOrder',
          name: '投诉工单',
          icon: ThunderboltOutlined,
          resource: manageCenterResource.complaintOrder,
          component: lazy(() => import('../pages/manageCenter/complaintOrder/orderList.jsx')),
        },
        {
          path: '/manageCenter/firmTest',
          name: '厂商总量检测',
          icon: SafetyOutlined,
          resource: manageCenterResource.firmTest && user?.userType === userTypeMap.platformUser,
          component: lazy(() => import('../pages/manageCenter/firmTest')),
        },
        {
          path: '/manageCenter/bikeManage',
          name: '车辆管理',
          icon: OneToOneOutlined,
          resource: manageCenterResource.bikeManage && !!region?.entityCode,
          component: lazy(() => import('../pages/manageCenter/bikeManage')),
        },
        {
          path: '/manageCenter/parkingManage',
          name: '停车点管理',
          icon: BellOutlined,
          resource: manageCenterResource.parkingManage && !!region?.entityCode,
          component: lazy(() => import('../pages/manageCenter/parkingManage')),
        },
        {
          path: '/manageCenter/userCreditManage',
          name: '用户信用行为管理',
          icon: CreditCardOutlined,
          resource: manageCenterResource.userCreditManage && !!region?.entityCode,
          component: lazy(() => import('../pages/manageCenter/userCreditManage')),
        },
        {
          path: '/manageCenter/operationOrder',
          name: '运维工单',
          icon: ProjectOutlined,
          resource: manageCenterResource.opereationOrder && !!region?.entityCode,
          component: lazy(() => import('../pages/manageCenter/opereationOrder')),
        },
        {
          path: '/manageCenter/operationUser',
          name: '运维人员信息',
          icon: UserOutlined,
          resource: manageCenterResource.operatorBaseInfoOperatorList && !!region?.entityCode,
          component: lazy(() => import('../pages/manageCenter/opereationUsers/index')),
        },
        {
          path: '/manageCenter/schoolManage',
          name: manageCenterResource.schoolManage?.resourceName || '自有车管理',
          icon: ProfileOutlined,
          resource: manageCenterResource.schoolManage && !!region?.entityCode,
          routes: [
            {
              path: '/manageCenter/schoolManage/miniProgramAccount',
              name: '小程序用户账号',
              resource: manageCenterResource.schoolAccount,
              component: lazy(() => import('../pages/manageCenter/schoolManage/account')),
            },
            {
              path: '/manageCenter/schoolManage/configCenter',
              name: '配置中心',
              resource: manageCenterResource.schoolConfigCenter,
              component: lazy(() => import('../pages/manageCenter/schoolManage/configCenter')),
            },
            {
              path: '/manageCenter/schoolManage/bikeManage',
              name: '车辆管理',
              resource: manageCenterResource.schoolBikeManage,
              component: lazy(() => import('../pages/manageCenter/schoolManage/bike')),
            },
            {
              path: '/manageCenter/schoolManage/bikeRecordManage',
              name: '车辆备案号管理',
              resource: manageCenterResource.schoolBikeRecordManage,
              component: lazy(() => import('../pages/manageCenter/schoolManage/bikeRecord')),
            },
            {
              path: '/manageCenter/schoolManage/bikeDealRecord',
              name: '处置记录',
              resource: manageCenterResource.schoolBikeDealRecord,
              component: lazy(() => import('../pages/manageCenter/schoolManage/dealRecord')),
            },
            {
              path: '/manageCenter/schoolManage/breatheRecord',
              name: '外呼记录',
              resource: manageCenterResource.schoolBreatheRecord,
              component: lazy(() => import('../pages/manageCenter/schoolManage/breatheRecord')),
            },
            {
              path: '/manageCenter/schoolManage/privacyNumberReport',
              name: '隐私号实名报备',
              resource: manageCenterResource.schoolPrivacyNumberReport,
              component: lazy(
                () => import('../pages/manageCenter/schoolManage/privacyNumberReport')
              ),
            },
            {
              path: '/manageCenter/schoolManage/deviceManage',
              name: '设备管理',
              resource: manageCenterResource.schoolDeviceManage,
              component: lazy(() => import('../pages/manageCenter/schoolManage/deviceManage')),
            },
            {
              path: '/manageCenter/schoolManage/passageRecord',
              name: '出入记录',
              resource: manageCenterResource.schoolPassageRecord,
              component: lazy(() => import('../pages/manageCenter/schoolManage/passageRecord')),
            },
          ],
        },
        {
          path: '/manageCenter/exclusiveManage',
          name: '专属车管理',
          resource: manageCenterResource.exclusiveManage && !!region?.entityCode,
          icon: RobotOutlined,
          routes: [
            {
              path: '/manageCenter/exclusiveManage/userManage',
              name: '专属人员信息',
              component: lazy(() => import('../pages/manageCenter/exclusiveManage/userManage')),
            },
            {
              path: '/manageCenter/exclusiveManage/carManage',
              name: '专属车辆信息',
              component: lazy(() => import('../pages/manageCenter/exclusiveManage/carManage')),
            },
            {
              path: '/manageCenter/exclusiveManage/recordManage',
              name: '专属车骑行记录',
              component: lazy(() => import('../pages/manageCenter/exclusiveManage/recordManage')),
            },
          ],
        },
        {
          path: '/manageCenter/orderManage',
          name: '订单管理',
          resource: manageCenterResource.orderManage && !!region?.entityCode,
          icon: ShopOutlined,
          component: lazy(() => import('../pages/manageCenter/orderManage')),
        },
        {
          path: '/manageCenter/manageReport',
          name: '经营日报',
          resource: manageCenterResource.manageReport && !!region?.entityCode,
          icon: CalendarOutlined,
          component: lazy(() => import('../pages/manageCenter/manageReport')),
        },
        {
          path: '/manageCenter/expenseData',
          name: '结费数据',
          resource: manageCenterResource.expenseData && !!region?.entityCode,
          icon: AccountBookOutlined,
          component: lazy(() => import('../pages/manageCenter/expenseData')),
        },
        {
          path: '/manageCenter/userVehicleReservationInfo',
          name: '用户车辆预约信息',
          resource: manageCenterResource.userVehicleReservationInfo && !!region?.entityCode,
          icon: CalendarOutlined,
          component: lazy(() => import('../pages/manageCenter/userVehicleReservationInfo')),
        },
        {
          path: '/manageCenter/userFeedbackInfo',
          name: '用户意见反馈信息',
          resource: manageCenterResource.userFeedbackInfo && !!region?.entityCode,
          icon: StarOutlined,
          component: lazy(() => import('../pages/manageCenter/userFeedbackInfo')),
        },
        {
          path: '/manageCenter/gbcertifiedVehicleManage',
          name: '新国标认证车辆管理',
          resource: manageCenterResource.gbcertifiedVehicleManage,
          icon: ProfileOutlined,
          component: lazy(() => import('../pages/manageCenter/gbcertifiedVehicleManage')),
        },
        { path: '*', component: require('../pages/notFound').default },
      ],
    },
  ]
  return manageCenterRoutes
}
